import React from 'react';

import * as StyledTabs from './tabs.styles';

interface Props {
	titles: string[];
	activeTab: string;
	setActiveTab: (tab: string) => void;
}

const TabTitles = ({ titles, activeTab, setActiveTab }: Props) => {
	return (
		<StyledTabs.TabTitles>
			{titles.map(title => (
				<StyledTabs.TabTitle active={activeTab === title} onClick={() => setActiveTab(title)}>
					{title}
				</StyledTabs.TabTitle>
			))}
		</StyledTabs.TabTitles>
	);
};

export default TabTitles;
